




















































































import {Component, Prop, Vue} from 'vue-property-decorator';
import { Store } from 'vuex';
import PageHeader from '../../../components/vui-luma/Ui/PageHeader.vue';
import StatusesCategories from '../../../components/Contacts/StatusesCategories.vue';
import AddContactModal from '../../../components/Contacts/AddContactModal.vue';
import ContactNoteModal from '../../../components/Contacts/ContactNoteModal.vue';
import PageSeparator from '../../../components/vui-luma/Ui/PageSeparator.vue';
import CustomSelectInput from '../../../components/vui-luma/Ui/CustomSelectInput.vue';
import MdIcon from '../../../components/vui-luma/Ui/MdIcon.vue';
import {FmvInputGroupMerge} from 'fmv-input-group-merge';
import {dispatchGetContacts} from '@/store/contacts/actions';
import {readContacts} from '@/store/contacts/getters';

@Component({
  components: {
    PageHeader,
    PageSeparator,
    MdIcon,
    FmvInputGroupMerge,
    StatusesCategories,
    CustomSelectInput,
    AddContactModal,
    ContactNoteModal,
  },
})
export default class Contacts extends Vue {
  public perPage = 20;
  public addContactVisible = false;
  public currentPage = 1;
  public searchText = '';
  public contact = null;
  public fieldsNames = [
      {
        key: 'first_name',
        label: 'Имя',
        sortable: true,
      }, {
        key: 'last_name',
        label: 'Фамилия',
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      }, {
        key: 'phone',
        label: 'Телефон',
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      }, {
        key: 'email',
        label: 'Email',
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      }, {
        key: 'params',
        label: '',
        thClass: 'text-right',
        tdClass: 'text-right',
      },
  ];

  public async created() {
    await dispatchGetContacts(this.$store, {});
    const contacts = readContacts(this.$store);
  }

  get contacts() {
    return readContacts(this.$store);
  }

  public rows() {
    return this.contacts.length;
  }

  public handleEditModal(contact) {
    this.contact = contact;
  }
}
